import React, { useEffect, useState } from "react";
import axios from "axios";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartOptions } from "chart.js";
import AspirasiBerandaSkeleton from "../../../../Components/loading/skeletonBeranda";
import TableVoteBeranda from "./tableVoteBeranda";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

interface TopPejabat {
  presiden_id: number;
  presiden?: string; // asumsi API kirim nama
  avg_nilai: number;
  total_vote: number;
  latest_vote: string;
}

const VoteBeranda = () => {
  const [topPejabat, setTopPejabat] = useState<TopPejabat[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchSummary = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/quisioners/summary`);
      setTopPejabat(res.data.top5);
    } catch (err) {
      console.error("Gagal fetch quisioner summary:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSummary();
  }, []);

  if (loading)
    return (
      <div>
        <AspirasiBerandaSkeleton />
      </div>
    );

  // Data untuk Bar Chart
  const data = {
    labels: topPejabat.map((p) => p.presiden || `Pejabat #${p.presiden_id}`),
    datasets: [
      {
        label: "Rata-rata Nilai",
        data: topPejabat.map((p) => p.avg_nilai),
        backgroundColor: "#cfa84d",
      },
    ],
  };

  const options: ChartOptions<"bar"> = {
    responsive: true,
    plugins: {
      legend: {
        position: "top" as const,
      },
    },
    scales: {
      x: {
        grid: { display: false },
      },
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0,
        },
      },
    },
  };

  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-lg font-bold mb-4">Nilai Vote Pejabat dengan (Rata-rata Tertinggi)</h2>
          <table className="w-full border border-gray-200">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-4 py-2">Nama Pejabat</th>
                <th className="px-4 py-2">Rata-rata Nilai</th>
                <th className="px-4 py-2">Total Vote</th>
              </tr>
            </thead>
            <tbody>
              {topPejabat?.map((p, idx) => (
                <tr key={idx} className="border-b text-center">
                  <td className="px-4 py-2">{p.presiden || `Pejabat #${p.presiden_id}`}</td>
                  <td className="px-4 py-2">{p.avg_nilai}</td>
                  <td className="px-4 py-2">{p.total_vote}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* --- Chart --- */}
        <div className="bg-white p-6 rounded-lg shadow flex flex-col items-center">
          <h2 className="text-lg font-bold mb-4">Perbandingan Rata-rata Nilai</h2>
          <div className="w-full max-w-lg">
            <Bar data={data} options={options} />
          </div>
        </div>
      </div>

      <div className="mt-5">
        <TableVoteBeranda />
      </div>
    </>
  );
};

export default VoteBeranda;
